package com.projectas.app.domain

import com.projectas.app.util.Resource

enum class Feature(
    val title: String,
    val subtitle: String,
    val icon: String,
) {
    Projects(
        title = "Projects",
        subtitle = "Organize all tasks under structured development projects.",
        icon = Resource.Icon.CODE
    ),

    Versioning(
        title = "Versioning",
        subtitle = "Keep tasks aligned with project versions automatically.",
        icon = Resource.Icon.DEPLOYED_CODE
    ),

    Tracking(
        title = "Tracking",
        subtitle = "Track time spent on every task with precision.",
        icon = Resource.Icon.TRENDING_UP
    ),

    Analytics(
        title = "Analytics",
        subtitle = "Gain insights with stats, trends, and heat maps.",
        icon = Resource.Icon.PIE_CHART
    ),

    Deadlines(
        title = "Deadlines",
        subtitle = "Set due dates and manage project timelines easily.",
        icon = Resource.Icon.ALARM
    ),

    Notifications(
        title = "Notifications",
        subtitle = "Get real-time alerts before tasks or projects expire.",
        icon = Resource.Icon.NOTIFICATION_BELL
    ),
}